<template>
  <div class="web-box-all" v-if="isMobile==false">
    <div class="web-login-header">
      <div class="web-login-header-main">
        <div class="web-login-header-logo">
          <img src="@/assets/icon/logo.png"/>
        </div>
        <div class="web-login-header-info">
          <p>弗兰卡再供应 赋能未来</p>
        </div>
      </div>
    </div>

    <div class="web-login-banner">
      <div class="web-login-banner-img" :style="{ height: main_height+'px'}">
      <img src="@/assets/login_bj.png" :style="{ height: main_height+'px'}">
    </div>
      <div class="web-login-banner-main">

        <div class="web-login-form">
          <h2>
            <a class="select">新用户注册</a>
            <a></a>
          </h2>
          <div class="web-login-form-data">

              <div class="web-login-form-left">
                  <ul>
                      <li>
                          <p>
                          <a>
                              <img src="@/assets/icon/login05.png"/>
                          </a>
                          <b>
                              <input type="text" maxlength="80" v-model="store_internation_no" @keyup.enter="post_data()" value="" placeholder="餐厅国际编号"/>
                          </b>
                          </p>
                      </li>
                      <li>
                          <p>
                          <a>
                              <img src="@/assets/icon/login05.png"/>
                          </a>
                          <b>
                              <input type="text" maxlength="80" v-model="store_no" @keyup.enter="post_data()" value="" placeholder="4 位数餐厅编号"/>
                          </b>
                          </p>
                      </li>
                      <li>
                          <p>
                          <a>
                              <img src="@/assets/icon/login05.png"/>
                          </a>
                          <b>
                              <input type="text" maxlength="80" v-model="store_name"  @keyup.enter="post_data()" value="" placeholder="餐厅名称"/>
                          </b>
                          </p>
                      </li>
                      <li>
                          <p>
                          <a>
                              <img src="@/assets/icon/login05.png"/>
                          </a>
                          <b>
                              <input type="text" maxlength="80" v-model="store_tel"  @keyup.enter="post_data()" value="" placeholder="门店固话（带区号）"/>
                          </b>
                          </p>
                      </li>
                      <li>
                          <p>
                          <a>
                              <img src="@/assets/icon/login05.png"/>
                          </a>
                          <b>
                              <input type="text" maxlength="80" v-model="store_user_name"  @keyup.enter="post_data()" value="" placeholder="餐厅总经理姓名"/>
                          </b>
                          </p>
                      </li>
                      <li>
                          <p>
                          <a>
                              <img src="@/assets/icon/login05.png"/>
                          </a>
                          <b>
                              <input type="text" maxlength="80" v-model="store_user_phone"  @keyup.enter="post_data()" value="" placeholder="餐厅总经理手机号"/>
                          </b>
                          </p>
                      </li>
                      <li>
                          <p>
                          <a>
                              <img src="@/assets/icon/login05.png"/>
                          </a>
                          <b>
                              <input type="text" maxlength="80" v-model="store_om_name"  @keyup.enter="post_data()" value="" placeholder="OM姓名"/>
                          </b>
                          </p>
                      </li>
                      <li>
                          <p>
                          <a>
                              <img src="@/assets/icon/login05.png"/>
                          </a>
                          <b>
                              <input type="text" maxlength="80" v-model="store_email"  @keyup.enter="post_data()" value="" placeholder="餐厅E-mail地址"/>
                          </b>
                          </p>
                      </li>
                      <li>
                          <p>
                          <a>
                              <img src="@/assets/icon/login05.png"/>
                          </a>
                          <b>
                              <input type="text" maxlength="80" v-model="store_opening_date"  @keyup.enter="post_data()" value="" placeholder="开业日期"/>
                          </b>
                          </p>
                      </li>
                      <li>
                          <p>
                            <a>
                                <img src="@/assets/icon/login05.png"/>
                            </a>
                            <b>
                                <b-form-select
                                  v-model="city.province"
                                  placeholder="请选择省"
                                  @change="changePro"
                                >
                                  <b-form-select-option value="">请选择省</b-form-select-option>
                                  <b-form-select-option
                                    v-for="item in addressData"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.name"
                                  >
                                  </b-form-select-option>
                                </b-form-select>
                                <b-form-select
                                  v-model="city.city"
                                  placeholder="请选择市"
                                  @change="changeCity"
                                >
                                <b-form-select-option value="">请选择市</b-form-select-option>
                                  <b-form-select-option
                                    v-for="item in cityData"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.name"
                                  >
                                  </b-form-select-option>
                                </b-form-select>
                                <b-form-select
                                  v-model="city.district"
                                  placeholder="请选择区"
                                  @change="changeArea"
                                >
                                <b-form-select-option value="">请选择区</b-form-select-option>
                                  <b-form-select-option
                                    v-for="item in areaData"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.name"
                                  >
                                  </b-form-select-option>
                                </b-form-select>
                              </b>
                          </p>
                      </li>
                      <li>
                          <p>
                          <a>
                              <img src="@/assets/icon/login05.png"/>
                          </a>
                          <b>
                              <input type="text" maxlength="80" v-model="store_address"  @keyup.enter="post_data()" value="" placeholder="地址"/>
                          </b>
                          </p>
                      </li>
                      <li>
                          <p>
                          <a>
                              <img src="@/assets/icon/login05.png"/>
                          </a>
                          <b>
                              <input type="text" maxlength="80" v-model="store_invoice"  @keyup.enter="post_data()" value="" placeholder="开票抬头"/>
                          </b>
                          </p>
                      </li>
                      <li style="width:100%;">
                          <h4 style="width:31%;" id="post_data" @click="post_data()">确定注册</h4>
                          <a  @click="set_login()" style="width:100px; height:40px; line-height:40px; font-size:15px; color:#333333; cursor: pointer; margin-left:20px;">返回登录</a>
                      </li>
                  </ul>
              </div>
          </div>

        </div>

      </div>
    </div>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>

  </div>

  <div v-else class="web-box-all">
    <div class="app-login-header">
      <div class="app-login-header-main">
        <div class="app-login-header-logo">
          <img src="@/assets/icon/logo.png"/>
        </div>
        <div class="app-login-header-info">
          <p>弗兰卡再供应 赋能未来</p>
        </div>
      </div>
    </div>

    <div class="app-register-box">
      <div class="app-register-title">
        <p>新用户注册</p>
      </div>
      <div class="app-register-from">
        <ul>
            <li>
                <p>
                <a>
                    <img src="@/assets/icon/login05.png"/>
                </a>
                <b>
                    <input type="text" maxlength="80" v-model="store_internation_no" @keyup.enter="post_data()" value="" placeholder="餐厅国际编号"/>
                </b>
                </p>
            </li>
            <li>
                <p>
                <a>
                    <img src="@/assets/icon/login05.png"/>
                </a>
                <b>
                    <input type="text" maxlength="80" v-model="store_no" @keyup.enter="post_data()" value="" placeholder="4 位数餐厅编号"/>
                </b>
                </p>
            </li>
            <li>
                <p>
                <a>
                    <img src="@/assets/icon/login05.png"/>
                </a>
                <b>
                    <input type="text" maxlength="80" v-model="store_name"  @keyup.enter="post_data()" value="" placeholder="餐厅名称"/>
                </b>
                </p>
            </li>
            <li>
                <p>
                <a>
                    <img src="@/assets/icon/login05.png"/>
                </a>
                <b>
                    <input type="text" maxlength="80" v-model="store_tel"  @keyup.enter="post_data()" value="" placeholder="门店固话（带区号）"/>
                </b>
                </p>
            </li>
            <li>
                <p>
                <a>
                    <img src="@/assets/icon/login05.png"/>
                </a>
                <b>
                    <input type="text" maxlength="80" v-model="store_user_name"  @keyup.enter="post_data()" value="" placeholder="餐厅总经理姓名"/>
                </b>
                </p>
            </li>
            <li>
                <p>
                <a>
                    <img src="@/assets/icon/login05.png"/>
                </a>
                <b>
                    <input type="text" maxlength="80" v-model="store_user_phone"  @keyup.enter="post_data()" value="" placeholder="餐厅总经理手机号"/>
                </b>
                </p>
            </li>
            <li>
                <p>
                <a>
                    <img src="@/assets/icon/login05.png"/>
                </a>
                <b>
                    <input type="text" maxlength="80" v-model="store_om_name"  @keyup.enter="post_data()" value="" placeholder="OM姓名"/>
                </b>
                </p>
            </li>
            <li>
                <p>
                <a>
                    <img src="@/assets/icon/login05.png"/>
                </a>
                <b>
                    <input type="text" maxlength="80" v-model="store_email"  @keyup.enter="post_data()" value="" placeholder="餐厅E-mail地址"/>
                </b>
                </p>
            </li>
            <li>
                <p>
                <a>
                    <img src="@/assets/icon/login05.png"/>
                </a>
                <b>
                    <input type="text" maxlength="80" v-model="store_opening_date"  @keyup.enter="post_data()" value="" placeholder="开业日期"/>
                </b>
                </p>
            </li>
            <li>
                <p>
                  <a>
                      <img src="@/assets/icon/login05.png"/>
                  </a>
                  <b>
                      <b-form-select
                        v-model="city.province"
                        placeholder="请选择省"
                        @change="changePro"
                      >
                        <b-form-select-option value="">请选择省</b-form-select-option>
                        <b-form-select-option
                          v-for="item in addressData"
                          :key="item.code"
                          :label="item.name"
                          :value="item.name"
                        >
                        </b-form-select-option>
                      </b-form-select>
                      <b-form-select
                        v-model="city.city"
                        placeholder="请选择市"
                        @change="changeCity"
                      >
                      <b-form-select-option value="">请选择市</b-form-select-option>
                        <b-form-select-option
                          v-for="item in cityData"
                          :key="item.code"
                          :label="item.name"
                          :value="item.name"
                        >
                        </b-form-select-option>
                      </b-form-select>
                      <b-form-select
                        v-model="city.district"
                        placeholder="请选择区"
                        @change="changeArea"
                      >
                      <b-form-select-option value="">请选择区</b-form-select-option>
                        <b-form-select-option
                          v-for="item in areaData"
                          :key="item.code"
                          :label="item.name"
                          :value="item.name"
                        >
                        </b-form-select-option>
                      </b-form-select>
                    </b>
                </p>
            </li>
            <li>
                <p>
                <a>
                    <img src="@/assets/icon/login05.png"/>
                </a>
                <b>
                    <input type="text" maxlength="80" v-model="store_address"  @keyup.enter="post_data()" value="" placeholder="地址"/>
                </b>
                </p>
            </li>
            <li>
                <p>
                <a>
                    <img src="@/assets/icon/login05.png"/>
                </a>
                <b>
                    <input type="text" maxlength="80" v-model="store_invoice"  @keyup.enter="post_data()" value="" placeholder="开票抬头"/>
                </b>
                </p>
            </li>
            <li style="width:100%; height:100px;"></li>
        </ul>
      </div>
      <div class="app-register-bottom">
        <p style="width:45%; background: #dddddd; color:#666666;" @click="set_login()">返回登录</p>
        <p style="width:45%;" id="post_data" @click="post_data()">确定注册</p>
      </div>
    </div>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>
  </div>

</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import request from '@/utils/request'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'
import $ from 'jquery'
import address from '@/utils/address.json'
import Toast from '@/components/toast/index'

export default {
  name: 'register',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-toast': Toast
  },
  data () {
    return {
      title: '注册',
      store_internation_no: '',
      store_no: '',
      store_name: '',
      store_tel: '',
      store_user_name: '',
      store_user_phone: '',
      store_om_name: '',
      store_email: '',
      store_opening_date: '',
      store_address: '',
      store_invoice: '',
      //  省数据
      addressData: [],
      //  市数据
      cityData: [],
      // 区数据
      areaData: [],
      main_height: 0,
      city: {
      // 省
        province: '',
        // 市
        city: '',
        // 区
        district: ''
      },
      toast_state: 'display:none',
      toast_text: '',
      isMobile: false
    }
  },
  created () {
  // 省份数据初始化
    this.addressData = address
  },
  unmounted () {
    window.removeEventListener('resize', this.updateIsMobile())
  },
  mounted () {
    window.removeEventListener('resize', this.updateIsMobile())

    localStorage.setItem('accessToken', '')
    $('#login_type').val(['2'])

    localStorage.setItem('store_info', '')

    this.main_height = $(window).height() - 180

    this.load_data()
  },
  methods: {
    updateIsMobile () {
      this.isMobile = window.innerWidth < 768
    },
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 3000)
    },
    // 省份更改
    changePro (e) {
    // 从省中过滤出市的数据
      this.cityData = this.addressData.filter((item) => {
        return item.name === e
      })[0].children
      // 省发生改变的时候 清空输入框市区街道的内容
      this.form.district = ''
      this.form.city = ''
      // 省发生更改时 该表空区街道数据的内容
      this.areaData = []
    },
    // 市更改
    changeCity (e) {
    // 获取到区的数据
      this.areaData = this.cityData.filter(
        (item) => item.name === e
      )[0].children
      // 清空数据后面对应数组的数据
      this.form.district = ''
    },
    // 区更改
    changeArea (e) {
      let temp = this.areaData.filter((item) => item.name === e)
      // 获取到区的code码
      this.form.regionalNumber = temp[0].code
      // 获取到街道的数据
      this.jdData = this.areaData.filter((item) => item.name === e)[0].children
    },
    verify_post (type) {
      if (type === true) {
        $('#post_data').css({'background': '#cccccc'})
      } else {
        $('#post_data').css({'background': '#d81e06'})
      }
    },
    set_login () {
      this.$router.push('/login')
    },
    load_data () {
      var that = this
      request({
        url: '/store/api/get_app_copy',
        method: 'post',
        data: {
          uid: '0'
        }
      }).then(ret => {
        if (ret && ret.code === 'success') {
          that.copyright_info = ret.data.copyright_info
          that.company_icp = ret.data.company_icp
          that.company_tel = ret.data.company_tel
        } else {
          that.toast(ret.msg)
        }
      })
    },
    post_data () {
      var that = this

      this.verify_post(true)

      request({
        url: '/store/api/register',
        method: 'post',
        data: {
          store_internation_no: that.store_internation_no,
          store_no: that.store_no,
          store_name: that.store_name,
          store_tel: that.store_tel,
          store_user_name: that.store_user_name,
          store_user_phone: that.store_user_phone,
          store_om_name: that.store_om_name,
          store_email: that.store_email,
          store_opening_date: that.store_opening_date,
          store_city: that.city.province + ' ' + that.city.city + ' ' + that.city.district,
          store_address: that.store_address,
          store_invoice: that.store_invoice
        }
      }).then(ret => {
        that.verify_post(false)
        if (ret && ret.code === 'success') {
          that.toast(ret.msg)
          setTimeout(function () {
            that.$router.push('/login')
          }, 2500)
        } else {
          that.toast(ret.msg)
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}

.web-login-header { width:100%; height:100px;}
  .web-login-header-main { width:1000px; height:100px; margin:0px auto; flex-flow:row; justify-content:space-between;}
    .web-login-header-logo { width:auto; height:70px; margin-top:15px;}
      .web-login-header-logo img { width:auto; height:70px;}
    .web-login-header-info { width:auto; height:100px;}
      .web-login-header-info p { width:auto; height:30px; line-height: 30px; font-size:16px; color:#666666; margin-top:45px;}

.ext-footer-box { width:100%; height:auto;}
.ext-footer-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
    .ext-footer-link { width:100%; height:30px; padding:0px 30px; margin-top:10px; }
        .ext-footer-link p { width:100%; height:40px; line-height:40px; margin:0px; flex-flow:row; justify-content:center;align-content:center;}
        .ext-footer-link p a { width:auto; height:40px; cursor: pointer; position: relative; line-height:40px; padding:0px 10px; font-size:12px; color:#666666;}
        .ext-footer-link p a i { width:1px; height:12px; position:absolute; top:15px; left:0px; border-right: 1px solid #cccccc; }
        .ext-footer-link p a:hover  { color:#d81e06;}
    .ext-footer-copy { width:100%; height:20px;margin-top:20px;flex-wrap:wrap; align-content:flex-start;}
        .ext-footer-copy ul { width:100%; height:24px; list-style: none; line-height:24px; flex-flow:row; justify-content:center; margin:0px;}
        .ext-footer-copy ul li { width:auto; height:24px; font-weight: normal; position: relative; line-height:24px; padding:0px 10px; font-size:12px; color:#666666;}
        .ext-footer-copy ul li i { width:1px; height:12px; position:absolute; top:3px; left:0px; border-right: 1px solid #cccccc; }
        .ext-footer-copy ul li a { color:#666666; cursor: pointer;}
        .ext-footer-copy ul li a:hover  { color:#d81e06;}

.web-login-banner { width:100%; height:475px; background: #d81e06;
min-height:475px;
width: 100%;
background-image: url(https://parts.franke.cn/lemon_pro/static/svg/svg.svg);
background-repeat: no-repeat;
background-position: 50%;
background-size: 90%;
height: 475px;
overflow: hidden;

}
  .web-login-banner-main { width:1000px; height:auto; margin:0px auto; position: relative;}
  .web-login-form { width:1000px; height:460px; display: flex; flex-wrap:wrap; align-content:flex-start;  position:absolute;top:35px; left:0px; background: #ffffff;}

  .web-login-form-data { width:100%; height:auto; float:left; display: flex; flex-flow:row; align-content:flex-start;  }
  .web-login-form-left { width:100%; height:auto; float:left; flex-wrap:wrap; align-content:flex-start; }
  .web-login-form h2 { width:100%; height:55px; margin-top:0px; border-bottom: 1px solid #f4f4f4;}
    .web-login-form h2 a { width:50%; height:50px; line-height:50px; padding-left:15px; font-size:18px; color:#333333;}
    .web-login-form h2 a.select { color:#d81e06; font-weight: bold;}
    .web-login-form-left ul { width:100%; height:auto; padding:0px 20px; margin-top:10px; flex-wrap:wrap; align-content:flex-start;}
    .web-login-form-left ul li { width:33%; height:45px; margin-top:20px; padding-right:30px;}
    .web-login-form-left ul li p { width:100%; height:45px; overflow: hidden; border: 1px solid #bdbdbd; border-radius: 4px; display: flex; flex-flow:row; justify-content:flex-start; }
    .web-login-form-left ul li p a { width:40px; height:45px;}
    .web-login-form-left ul li p a img { width:16px; height:16px; margin:14px 0px 0px 12px;}
    .web-login-form-left ul li p b { width:248px; height:45px; display: flex; flex-flow:row; justify-content:flex-start;}
    .web-login-form-left ul li p b input { width:240px; height:30px; margin-top:6px; border:0px; min-height:30px; margin-left:0px; font-size:14px; line-height: 30px; color:#333333;}
    .web-login-form-left ul li p b select { width:100px !important; height:45px; float:left; border:0px; font-size:14px;border:none;outline:0;outline:none !important; margin-top:-2px; margin-left:-6px; box-sizing:border-box;}
    .web-login-form-left ul li p b select:focus{ border-color:#fff; -webkit-box-shadow:none; box-shadow:none;}
    .web-login-form-left ul li p b select option { width:100px; height:45px;}
    .web-login-form-left ul li h3 { width:100%; height:20px; justify-content:flex-end;}
    .web-login-form-left ul li h3 a { width:100px; height:20px; cursor: pointer; line-height:20px; text-align: right; justify-content:flex-end; font-size:12px; color:#333333;}

    .web-login-form-left ul li h4 { width:100%; height:45px; cursor: pointer; line-height:45px; font-size:18px; background: #d81e06; color:#ffffff; border-radius: 4px; text-align: center; justify-content:center; }

    .web-login-banner-img { width:100%; height:80vh; position:absolute; top:100px; left:0px;}
.web-login-banner-img img { width:100%; height:100%;object-fit: cover;}

.app-login-header { width:100%; height:60px;}
  .app-login-header-main { width:100%; height:50px; margin:0px auto; padding:0px 15px; flex-flow:row; justify-content:space-between;}
    .app-login-header-logo { width:auto; height:35px; margin-top:15px;}
      .app-login-header-logo img { width:auto; height:35px;}
    .app-login-header-info { width:auto; height:50px;}
      .app-login-header-info p { width:auto; height:30px; line-height: 30px; font-size:12px; color:#666666; margin-top:25px;}

.app-register-box { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
  .app-register-title { width:100%; height:40px; padding:0px 15px;}
  .app-register-title p { width:100%; height:40px; line-height: 40px; font-size:14px; color:#d81e06; font-weight: bold;}
  .app-register-from { width:100%; height:auto;}
    .app-register-from ul { width:100%; height:auto; padding:0px 20px; margin-top:10px; flex-wrap:wrap; align-content:flex-start;}
    .app-register-from li { width:100%; height:45px; margin-top:20px; padding-right:30px;}
    .app-register-from ul li p { width:100%; height:45px; overflow: hidden; border: 1px solid #bdbdbd; border-radius: 4px; display: flex; flex-flow:row; justify-content:flex-start; }
    .app-register-from ul li p a { width:40px; height:45px;}
    .app-register-from ul li p a img { width:16px; height:16px; margin:14px 0px 0px 12px;}
    .app-register-from ul li p b { width:248px; height:45px; display: flex; flex-flow:row; justify-content:flex-start;}
    .app-register-from ul li p b input { width:240px; height:30px; margin-top:6px; border:0px; min-height:30px; margin-left:0px; font-size:14px; line-height: 30px; color:#333333;}
    .app-register-from ul li p b select { width:100px !important; height:45px; float:left; border:0px; font-size:14px;border:none;outline:0;outline:none !important; margin-top:-2px; margin-left:-6px; box-sizing:border-box;}
    .app-register-fromt ul li p b select:focus{ border-color:#fff; -webkit-box-shadow:none; box-shadow:none;}
    .app-register-from ul li p b select option { width:100px; height:45px;}
    .app-register-from ul li h3 { width:100%; height:20px; justify-content:flex-end;}
    .app-register-from ul li h3 a { width:100px; height:20px; cursor: pointer; line-height:20px; text-align: right; justify-content:flex-end; font-size:12px; color:#333333;}

  .app-register-bottom { width:100%; height:70px; position: fixed; padding:10px 50px;display: flex; flex-flow:row; justify-content: space-between ;border-top:1px solid #efefef; bottom:0px; left:0px; background: #ffffff;}
  .app-register-bottom p { width:100%; height:40px; line-height: 40px; text-align: center; justify-content:center; font-size:15px; color: #ffffff; background: #d81e06;}
</style>



// WEBPACK FOOTER //
// src/pages/store/register.vue